import React from "react";
import { Routes, Route } from "react-router-dom";
import ListRentalProperties from "../Components/Rental Properties/listResaleProperties";
import ListInterestedPropertyResale from "../Components/Rental Properties/listInterestedPropertyResale";
import HeaderResaleProperty from "../Components/Rental Properties/headerResaleProperty";
import ViewResaleProperties from "../Components/Rental Properties/viewPropertyResale";
// import EditProperties from "../Components/Properties/editProperties";

const PropertiesRentalRoutes = () => {
  return (
    <Routes>
      <Route
        path="/rental_property/list"
        element={<HeaderResaleProperty></HeaderResaleProperty>}
      ></Route>
      <Route
        path="/rental_property"
        element={<ListRentalProperties></ListRentalProperties>}
      ></Route>
      <Route
        path="/rental_property/interested_list"
        element={<ListInterestedPropertyResale></ListInterestedPropertyResale>}
      ></Route>
      <Route
        path="/rental_property/view/:id"
        element={<ViewResaleProperties></ViewResaleProperties>}
      ></Route>
      {/* <Route
        path="/manage_properties/edit/:id"
        element={<EditProperties></EditProperties>}
      ></Route> */}
    </Routes>
  );
};

export default PropertiesRentalRoutes;
